import { useParams } from 'react-router'

// #INFO Single source for reading the connected (iDWELL-to-iDWELL) request's
// `outboundUuid` route param (undefined on regular routes), so the param name
// lives in one place.
export function useOutboundUuid() {
  return useParams().outboundUuid
}
